import { BASE_URL } from "../../config";
import { SET_LOAN_LIST, SET_ERROR_STATE, REQ_LOAN, REQ_LOAN_DONE } from "../../utils/constants/actionTypes";
import { GLoans, URL_API_GET_TIPE_PINJMAN } from "../../config/api";
import bugsnagClient from "../../config/bugsnag";
import axios from "axios";

export default (ClientID, status = []) =>
	async (dispatch) => {
		dispatch({ type: REQ_LOAN });
		let listStatus = "";
		if (status.length == 0) {
			listStatus = "/";
		} else {
			listStatus = "?";

			let i = 1;
			status.forEach((data) => {
				listStatus += `${i == 1 ? "" : "&"}status=${data}`;

				i++;
			});
		}
		//console.log({listStatus});
		const axiosInstance = axios.create({
			baseURL: BASE_URL,
			withCredentials: true,
			headers: {
				"X-Client-ID": ClientID,
				"Content-Type": "application/json",
			},
		});

		const getListLoan = axiosInstance.get(GLoans(listStatus));
		const getTipePinjaman = axiosInstance.get(URL_API_GET_TIPE_PINJMAN("all"));
		axios
			.all([getListLoan, getTipePinjaman])
			.then((res) => {
				const { loans } = res[0].data.result;
				const { products } = res[1].data.result;

				loans.map((item) => {
					let prod = products.find((data) => data.productUID === item.productUID);
					return (item.nameProductMapping = prod.productName);
				});

				dispatch({ type: SET_LOAN_LIST, payload: loans });
			})
			.catch((err) => {
				dispatch({ type: REQ_LOAN_DONE });
				dispatch({ type: SET_ERROR_STATE, payload: err.message });
				bugsnagClient.notify(new Error(`Loan.js/ (line 51) ===> catch - ${err.message}`));
			});

		/*
		try {
			let res = await fetch(`${BASE_URL}${GLoans(listStatus)}`, {
				method: "GET",
				credentials: "include",
				headers: {
					"X-Client-ID": ClientID,
					"Content-Type": "application/json",
				},
			});

			let hasil = await res.json();
			console.log({ hasil });

			if (res.status === 200) {
				dispatch({ type: SET_LOAN_LIST, payload: hasil.result.loans });
			} else {
				dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
				dispatch({ type: REQ_LOAN_DONE });
				bugsnagClient.notify(new Error(`Loan.js/ (line 37) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			}
		} catch (err) {
			dispatch({ type: SET_ERROR_STATE, payload: err.message });
			dispatch({ type: REQ_LOAN_DONE });
			bugsnagClient.notify(new Error(`Loan.js/ (line 42) ===> catch - ${err.message}`));
		}
        */
	};
